import { render, staticRenderFns } from "./IssueItem.vue?vue&type=template&id=695b265d&scoped=true&"
import script from "./IssueItem.vue?vue&type=script&lang=js&"
export * from "./IssueItem.vue?vue&type=script&lang=js&"
import style0 from "./IssueItem.vue?vue&type=style&index=0&id=695b265d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b265d",
  null
  
)

export default component.exports